const unitsHaveName = [69, 70, 82, 83, 85, 86, 87];

const getUnitName = (idCurso: number, order: number, unit: string) => {
    return unitsHaveName.includes(idCurso) ? unit : `Unit ${order}`;

}

export default getUnitName;
